<template>

  <div>
    <p>Por favor completa la siguiente información:</p>
    <form @submit.prevent="submit" novalidate>

      <!-- FORMULARIO DE PERSONA PEP -->
      <fieldset>

        <!-- PROFESION Y PUESTO -->
         <div class="row row-responsive">

           <!-- INICIA LA PROFESION -->
          <div class="column column-xs-100 column-sm-50">
            <label
              for="profession"
              :class="{'error-text': $v.userIsPep.profession.$invalid
                && formSubmitted
                || endpointErrors.profession }" >
                Profesión:
            </label>
            <input
              type="text"
              v-model.trim="$v.userIsPep.profession.$model"
              :class="{ 'error-label': $v.userIsPep.profession.$invalid
                && formSubmitted
                || endpointErrors.profession }"
              placeholder="Profesión"
            />
            <!-- INICIAN VALIDACIONES DE PROFESION -->
            <div
              v-if="formSubmitted && !$v.userIsPep.profession.required"
              class="error"
            >
              Este campo es obligatorio.
            </div>
            <div
              v-if="formSubmitted && !$v.userIsPep.profession.minLength"
              class="error"
            >
              La profesion es incorrecta.
            </div>
          </div>

          <!-- INICIA EL PUESTO -->
          <div class="column column-xs-100 column-sm-50">
            <label
              for="position"
              :class="{
                'error-text': $v.userIsPep.position.$invalid
                && formSubmitted
                || endpointErrors.position }">
                Posición:
            </label>
            <input
              type="text"
              v-model.trim="$v.userIsPep.position.$model"
              :class="{ 'error-label': $v.userIsPep.position.$invalid
                && formSubmitted
                || endpointErrors.position }"
              placeholder="Posición"
            />

            <!-- INICIAN VALIDACIONES DE PUESTO -->
            <div
              v-if="formSubmitted && !$v.userIsPep.position.required"
              class="error"
            >
              Este campo es obligatorio.
            </div>
            <div
              v-if="formSubmitted && !$v.userIsPep.position.minLength"
              class="error"
            >
              El puesto es incorrecto.
            </div>
          </div>
        </div>

        <!-- FECHAS DE INGRESO Y EGRESO -->
        <div class="row row-responsive">

          <!-- INICIA LA FECHA DE INGRESO -->
          <div class="column column-xs-100 column-sm-50">
            <label
              for="startWorkingDate"
              :class="{
                'error-text': $v.userIsPep.startWorkingDate.$invalid
                && formSubmitted
                || endpointErrors.startWorkingDate }">
              Fecha de inicio:
            </label>
            <DatePicker
              v-model.trim="$v.userIsPep.startWorkingDate.$model"
              :format="dateFormat"
              :monday-first="true"
              :disabled-dates="{from: new Date(), to: new Date(1900, 0, 0)}"
              :class="{ 'error-label': $v.userIsPep.startWorkingDate.$invalid
                && formSubmitted
                || endpointErrors.startWorkingDate }"
              :language="es"
              placeholder="Fecha de inicio (dd-mm-aaaa)">
            </DatePicker>

            <!-- INICIAN VALIDACIONES DE FECHA DE INGRESO -->
            <div
              v-if="formSubmitted && !$v.userIsPep.startWorkingDate.required"
              class="error"
            >
              Este campo es obligatorio.
            </div>
          </div>

          <!-- INICIA FECHA DE EGRESO -->
          <div class="column column-xs-100 column-sm-50">
            <label
              for="end_date"
              :class="{
                'error-text': $v.userIsPep.finishWorkingDate.$invalid
                && formSubmitted
                || endpointErrors.finishWorkingDate }">
              Fecha de término:
            </label>
            <DatePicker
              v-model.trim="$v.userIsPep.finishWorkingDate.$model"
              :format="dateFormat"
              :monday-first="true"
              :disabled-dates="{from: new Date(), to: new Date(1900, 0, 0)}"
              :class="{ 'error-label': $v.userIsPep.finishWorkingDate.$invalid
                && formSubmitted
                || endpointErrors.finishWorkingDate }"
              :language="es"
              placeholder="Fecha de término (dd-mm-aaaa)"
              :disabled="keepWorkingAt">
            </DatePicker>
            <input
              v-model="keepWorkingAt"
              type="checkbox"
              id="notkeepWorkingAt"
              name="notkeepWorkingAt"
            >
            <p
              class="checkbox--label"
              for="notkeepWorkingAt"
            >
              Actualmente continúo laborando.
            </p>
            <!-- INICIAN VALIDACIONES DE LA FECHA DE EGRESO -->
            <div
              v-if="formSubmitted && !$v.userIsPep.finishWorkingDate.requiredIf"
              class="error"
            >
              Este campo es obligatorio.
            </div>
            <div
              v-if="formSubmitted && !$v.userIsPep.finishWorkingDate.minorThan"
              class="error"
            >
              La fecha de término debe ser mayor que la fecha de inicio.
            </div>
          </div>
        </div>

        <!-- DEPENDENCIA Y EMPLEO ACTUAL -->
        <div class="row row-responsive">

          <!-- INICIA DEPENDENCIA DEL GOBIERNO -->
          <div class="column column-xs-100 column-sm-50">
            <label
              for="government_dependence"
              :class="{
                'error-text': $v.userIsPep.governmentDependence.$invalid
                && formSubmitted
                || endpointErrors.governmentDependence }">
              Dependencia del gobierno:
            </label>
            <input
              type="text"
              v-model.trim="$v.userIsPep.governmentDependence.$model"
              :class="{ 'error-label': $v.userIsPep.governmentDependence.$invalid
                && formSubmitted
                || endpointErrors.governmentDependence }"
              placeholder="Dependencia del gobierno"
            />

            <!-- INICIAN VALIDACIONES DE DEPENDENCIA DEL GOBIERNO -->
            <div
              v-if="formSubmitted && !$v.userIsPep.governmentDependence.required"
              class="error"
            >
              Este campo es obligatorio.
            </div>
            <div
              v-if="formSubmitted && !$v.userIsPep.governmentDependence.minLength"
              class="error"
            >
              La dependencia de gobierno es incorrecta.
            </div>
          </div>

          <!-- INICIA EMPLEO ACTUAL -->
          <div class="column column-xs-100 column-sm-50">
            <label
              for="current_job"
              :class="{
                'error-text': $v.userIsPep.currentJob.$invalid
                && formSubmitted
                || endpointErrors.currentJob }">
              Empleo actual:
            </label>
            <input
              type="text"
              v-model.trim="$v.userIsPep.currentJob.$model"
              :class="{ 'error-label': $v.userIsPep.currentJob.$invalid
                  && formSubmitted
                  || endpointErrors.currentJob }"
              placeholder="Empleo actual"
            />

            <!-- INICIAN VALIDACIONES DE EMPLEO ACTUAL -->
            <div
              v-if="formSubmitted && !$v.userIsPep.position.required"
              class="error"
            >
              Este campo es obligatorio.
            </div>
            <div
              v-if="formSubmitted && !$v.userIsPep.position.minLength"
              class="error"
            >
              La dependencia de gobierno es incorrecta.
            </div>
          </div>
        </div>

        <!-- FONDOS DEL GOBIERNO -->
        <div class="row row-responsive">

          <!-- INICIA FONDOS DEL GOBIERNO -->
          <div class="column column-xs-100 column-sm-50">
            <label
              for="government_funds"
              :class="{
                'error-text': $v.userIsPep.governmentFunds.$invalid
                && formSubmitted
                || endpointErrors.governmentFunds }">
              ¿Tienes o tuviste acceso a fondos de gobierno?
            </label>
            <span class="select">
              <select
                v-model.trim="$v.userIsPep.governmentFunds.$model"
                :class="{ 'error-label': $v.userIsPep.governmentFunds.$invalid
                    && formSubmitted
                    || endpointErrors.governmentFunds }"
              >
                <option value="" disabled selected>Seleccione:</option>
                <option
                  v-for="option in options"
                  :value="option.value" :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
              <span class="arrow"></span>
            </span>

            <!-- INICIAN VALIDACIONES DE FONDOS DEL GOBIERNO -->
            <div
              v-if="formSubmitted && !$v.userIsPep.governmentFunds.required"
              class="error"
            >
              Este campo es obligatorio.
            </div>
          </div>
          <!-- INICIA PREGUNTA DEPENDIENTES ECONÓMICOS -->
          <div class="column column-xs-100 column-sm-50">
            <label
              :class="{ 'error-text': $v.hasDependents.$invalid
              && formSubmitted }"
            >
              ¿Tienes dependientes económicos?
            </label>
            <input
              v-model="$v.hasDependents.$model"
              type="radio"
              id="dependentTrue"
              name="dependent"
              value="itHas"
            />
            <label class="radio--label" for="direct">
              Si
            </label>
            <input
              class="radio--ml"
              v-model="hasDependents"
              type="radio"
              id="dependentFalse"
              name="dependent"
              value="hasNot"
            />
            <label class="radio--label" for="indirect">
              No.
            </label>
            <!-- INICIAN VALIDACIONES PREGUNTA DEPENDIENTES -->
            <div
              v-if="formSubmitted && !$v.hasDependents.required"
              class="error"
            >
              Este campo es obligatorio.
            </div>
          </div>
        </div>

      </fieldset>

      <div v-if="hasDependents === 'itHas'">
          <DependentForm
            v-on:displayAllDependents="onDependentFormClick"
            v-if="!showAllDependents"
          />
          <DependentTable
            class="dependent-table--mb"
            v-on:displayAllDependents="onDependentFormClick"
            v-else />
      </div>
      <div class="btn-container" v-if="hasDependents !== 'itHas' || showAllDependents">
        <button
          class="button"
          @click.prevent="submit()">
          GUARDAR
        </button>
      </div>
    </form>
  </div>

</template>

<script>

import { required, minLength, maxLength, requiredIf }
  from 'vuelidate/lib/validators'
import DatePicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import { format, isAfter } from 'date-fns'

import DependentForm from '@/components/EconomicDependents/DependentForm'
import DependentTable from '@/components/EconomicDependents/DependentTable'

import mixins from '@/mixins/index'
import userProfileMixin from '@/mixins/userProfileMixin'
import httpRequestMixin from '@/mixins/httpRequestMixin'

export default {
  name: 'StepIsPep',
  components: {
    DatePicker,
    DependentForm,
    DependentTable
  },
  validations: {
    hasDependents: { required },
    userIsPep: {
      profession: { required, minLength: minLength(2) },
      position: { required, minLength: minLength(2) },
      startWorkingDate: {
        required,
        formattedDate (date) {
          return (
            /^([0-2][0-9]|(3)[0-1])(-)(((0)[0-9])|((1)[0-2]))(-)\d{4}$/.test(this.dateFormat(date))
          )
        }
      },
      finishWorkingDate: {
        requiredIf: requiredIf(() => { return this.keepWorkingAt }),
        formattedDate (date) {
          return (
            /^([0-2][0-9]|(3)[0-1])(-)(((0)[0-9])|((1)[0-2]))(-)\d{4}$/.test(this.dateFormat(date))
          )
        },
        minorThan (date) {
          if (this.keepWorkingAt) return true
          return this.isAfter(new Date(date),
            new Date(this.userIsPep.startWorkingDate))
        },
        maxLength: maxLength(10)
      },
      governmentDependence: { required, minLength: minLength(2) },
      currentJob: { required, minLength: minLength(2) },
      governmentFunds: { required }
    }
  },
  mixins: [mixins, userProfileMixin, httpRequestMixin],
  data () {
    return {
      showAllDependents: false,
      formSubmitted: false,
      keepWorkingAt: false,
      hasDependents: '',
      format,
      isAfter,
      es: es,
      options: [
        {
          name: 'No',
          value: false
        },
        {
          name: 'Si',
          value: true
        }
      ],
      endpointErrors: {
        profession: null,
        position: null,
        startWorkingDate: null,
        finishWorkingDate: null,
        government_dependence: null,
        current_job: null,
        gov_funds: null,
        dependents: []
      },
      userIsPep: {
        profession: null,
        position: null,
        startWorkingDate: null,
        finishWorkingDate: null,
        governmentDependence: null,
        currentJob: null,
        governmentFunds: '',
        dependents: []
      }
    }
  },
  methods: {
    onDependentFormClick: function (value) {
      this.showAllDependents = value
    },
    submit: function () {
      this.formSubmitted = true
      if (this.$v.userIsPep.$invalid) return false
      this.sendDataToServer()
    },
    sendDataToServer: async function () {
      const endDate = !this.keepWorkingAt
        ? format(this.userIsPep.finishWorkingDate, 'YYYY-MM-DD').toString()
        : null
      await this.$store.dispatch('refreshToken')
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/profile/peps/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        data: {
          start: format(
            this.userIsPep.startWorkingDate, 'YYYY-MM-DD').toString(),
          end: endDate,
          profession: this.userIsPep.profession,
          position: this.userIsPep.position,
          government_dependence: this.userIsPep.governmentDependence,
          current_job: this.userIsPep.currentJob,
          gov_funds: this.userIsPep.governmentFunds,
          dependents: this.$store.getters['pep/getDependents']
        }
      }
      const response = await this.httpRequest(options)
      if (response.status === 201) { this.nextStep() }
    }
  }
}

</script>

<style lang="scss" scoped>

.checkbox--label,
.radio--label {
  display: inline-block;
}

.radio--ml {
  margin-left: 1em;
}

.dependent-table--mb {
  margin-bottom: 3em;
}

.btn-container {
  display: flex;
  justify-content: end;
}

</style>



// WEBPACK FOOTER //
// src/views/userProfile/profileSteps/StepIsPep.vue